import Logo1 from '../../assets/NewLogoOptions/NLIX-Logo-25-Cyber-yellow-CMYK_cropped.png';
import Logo2 from '../../assets/NewLogoOptions/NLIX-Logo-25-Operator-orange-CMYK_cropped.png';
import Logo3 from '../../assets/NewLogoOptions/NLIX-Logo-25-Program-pink-CMYK_cropped.png';
import Logo4 from '../../assets/NewLogoOptions/NLIX-Logo-25-Terminal-purple-CMYK_cropped.png';

import React from "react";
import {Box} from "@mui/material";
import {SystemStyleObject} from "@mui/system";

const sxBase: SystemStyleObject = {
    '& svg': {
        width: '100%'
    },

    '& path': {
        transition: 'all 1s ease-out',
    },

};

const sxSmall: SystemStyleObject = {
    '& .logo-N': {
        opacity: 0
    },

    '& .logo-L': {
        opacity: 0
    },

    '& .logo-I': {
        opacity: 0
    },

    '& .logo-X': {
        transform: 'translateX(-36.608%)'
    }

};

const Logos = [Logo1, Logo2, Logo3, Logo4];

export default function Logo({small=true, sx} : {small:boolean, sx?: SystemStyleObject}) {
    const [randomLogoIndex] = React.useState(Math.floor(Math.random() * Logos.length));
    const currentLogo = Logos[randomLogoIndex];

    return (
        <Box
            sx={[sxBase, small && sxSmall, sx || false]}
        >
            <img
                src={currentLogo}
                alt="logo"
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    display: 'block'
                }}
            />
        </Box>
    );
}
